import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultRolesState, RolesState } from "../state/stateItems";
import { TRoleItem } from "@/data/types";
import { getAllRolesAsync, getRoleByIdAsync } from "../actions";

const handleGetAllRolesAsync = (
  state: RolesState,
  action: PayloadAction<{ items: TRoleItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetRoleByIdAsync = (
  state: RolesState,
  action: PayloadAction<{ items: TRoleItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  const role = items?.[0];
  if (role) state.currentRole = role;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<RolesState>) => {
  builder.addCase(getAllRolesAsync.fulfilled.type, handleGetAllRolesAsync);
  builder.addCase(getRoleByIdAsync.fulfilled.type, handleGetRoleByIdAsync);
};

export default createReducer(DefaultRolesState, reducerBuilder);
